import React, {useEffect,useState, useContext} from 'react';
import {InputSearch} from "../../components/layout/Interface";
import useForm from "../../hooks/useForm";
import {getGamesByName} from "../Queries/getGameByName";
import Game from "../main/Game";
import queryString from "query-string";
import { useLocation } from 'react-router-dom';
import {Error, InfoButton, SearchIcon} from "../layout/Interface";
import Spinner from "../ui/Spinner";
import InterfaceContext from "../../context/interface/interfaceContext";

const Search = ({history}) => {

    const location = useLocation();
    const {change, messageError, changeLoadTrue, changeLoadFalse, resultNegative, resultNegativeTrue} = useContext(InterfaceContext);
    const [games, setGames] = useState([]);
    const [error, setError] = useState(false);
    const [deleteGame, setDelete] = useState(false);
    const [send, setSend] = useState(false);

    const {q = ""} = (queryString.parse(location.search));
   
    
    const {handleChange, values} = useForm({
        search: q
    });
    
    const {search} = values;

    const  fetchData = async () => {
        const gamesResult = await getGamesByName(search);
        setGames(gamesResult);
        changeLoadFalse();
    }

    useEffect(() => {
        fetchData();
    },[q, deleteGame]);

    const handleSubmit = e => {
        e.preventDefault();

        if(search === ""){
           setError(true);
           setTimeout(() => {
                setError(false);
           }, 2000);
        }
        else if(search !== ""){
            changeLoadTrue();
            history.push(`?q=${search}`);
            setSend(true);
        }
    }

    return (
        <div className="bg-search">
            <div className="container p-1">
                <h1 className = "title white">Buscador de Juegos</h1>
                <div className="column-2-search">
                    <div className="search">
                        <form onSubmit = {handleSubmit} className = "p-relative">
                                <InputSearch type="text" name = "search" onChange = {handleChange} placeholder = "Nombre del juego..." className = "p-relative"/>
                                <SearchIcon></SearchIcon>
                                <input type="submit" className = "btn-submit  ml-5"/>
                        </form>
                        {error && <Error>Falta el nombre del juego</Error>}
                    </div>
                    <div className="search-game">
                        {
                            change ? (
                                <div className="flex-center-both">   
                                    <Spinner />
                                </div>
                            )
                            : (
                                <div className="flex-center">
                                    <div className="width-games">
                                    {
                                        games == 0 ? (<InfoButton>¡Busca el producto que deseas!</InfoButton>)  : (
                                            games.map(game => (
                                                <Game key = {game.id} game = {game} setDelete = {setDelete} />
                                            ))
                                        )
                                    }
                                    </div>
                                </div>
                            )
                        }   
                    </div>
                </div>
            </div>
        </div>

    );
}
 
export default Search;